import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Typography,
  } from "@mui/material";
  import { styled } from "@mui/material/styles";

  export const StyledDialog = styled(Dialog)`
    .MuiDialog-paper {
      background-color: #2d2b2c;
      color: #DCC6B7;
      width: 90%;
      max-width: 500px;
      box-sizing: border-box;
      padding: 32px 24px;
      border-radius: 16px;
      z-index: 9999;
      overflow: hidden;
      max-height: 100vh;
    }
  `;

  export const StyledDialogTitle = styled(DialogTitle)`
    color:  #DCC6B7;
    text-align: center;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: uppercase;
  `;
  
  export const StyledDialogContent = styled(DialogContent)`
    width: 100%;
    color: #ffffff;
    font-size: 1rem;
    padding: 0;
    overflow: hidden;
    max-width: 100%;
  `;
  
  export const StyledTypography = styled(Typography)`
  font-size: 1rem;
  color: #ffffff;
  text-align: center;
  margin-bottom: 24px;
  & strong {
    font-weight: bold;
    color: #ffffff;
  }`;
  
  export const StyledDialogCloseButton = styled(IconButton)`
    position: absolute;
    right: 8px;
    top: 8px;
    color: #DCC6B7;
  `;